import { defineStore } from 'pinia'

export const useRootStore = defineStore('root', {
  state: () => ({
    loading: [],
    errors: [],
    couponCode: '',
    couponDetails: {},
    couponError: {},
  }),

  actions: {
    addLoading(id) {
      if (!this.loading.includes(id)) {
        this.loading.push(id)
      }
    },

    removeLoading(id) {
      this.loading = this.loading.filter((item) => item !== id)
    },

    addError({ id, error }) {
      this.errors.push({ id, error })
    },

    removeError(id) {
      this.errors = this.errors.filter((error) => error.id !== id)
    },

    setCouponCode(couponCode) {
      this.couponCode = couponCode
      this.couponDetails = {}
      this.couponError = {}
    },

    removeCouponCode() {
      this.couponCode = ''
      this.couponDetails = {}
      this.couponError = {}
    },

    setCouponDetails(couponDetails) {
      this.couponCode = couponDetails?.code || ''
      this.couponDetails = { ...couponDetails }
      this.couponError = {}
    },

    setCouponError(couponError) {
      this.couponDetails = {}
      this.couponError = { ...couponError }
    },

    // This is a placeholder for the silentLogOut function
    // The actual implementation will depend on your auth module setup
    silentLogOut({ source }) {
      console.log(`Silent logout triggered from ${source}`)
      // In a real implementation, this would handle token refresh or logout
      // This will need to be connected to your authentication system
      return Promise.resolve() // Return a promise for async compatibility
    },
  },
})
